import { ApisauceInstance, create } from 'apisauce'

import { Config } from '@flowwai-frontend/bps-officer-web/env-config'
import {
   HTTP_ACCEPT_HEADER_VALUE,
   HTTP_CACHE_CONTROL_HEADER_VALUE,
   HTTP_CONTENT_TYPE_HEADER_VALUE,
   HTTP_PRAGMA_HEADER_VALUE
} from '@flowwai-frontend/shared/auth/common'

import endpoints from '../endPoints'
import {
   RefreshAuthTokensAPIRequestObjectType,
   RefreshAuthTokensResponseObjectType
} from '../types'

import RefreshTokenService from './'

const BASE_URL = Config.BACKEND_REST_URL

const URL = `${BASE_URL}api/iam/`

export class RefreshTokenServiceAPI implements RefreshTokenService {
   api: ApisauceInstance
   constructor() {
      this.api = create({
         baseURL: URL,
         headers: {
            'Content-Type': HTTP_CONTENT_TYPE_HEADER_VALUE,
            Accept: HTTP_ACCEPT_HEADER_VALUE,
            Pragma: HTTP_PRAGMA_HEADER_VALUE,
            'Cache-Control': HTTP_CACHE_CONTROL_HEADER_VALUE
         }
      })
   }
   getRefreshAuthTokensAPI = async (
      requestObject: RefreshAuthTokensAPIRequestObjectType
   ) => {
      const response = await this.api.post<RefreshAuthTokensResponseObjectType>(
         endpoints.refreshAuthTokens,
         requestObject
      )
      const data = response.data

      if (data && 'expires_in_seconds' in data) {
         return {
            access_token: data.access_token,
            refresh_token: data.refresh_token,
            expires_in_seconds: data.expires_in_seconds
         }
      }
      throw response
   }
}
